import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure36 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '1000px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},
credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},
plotOptions: {
series: {
borderWidth: 0,
stacking: 'normal',
}
},
exporting: {
enabled: false
},
xAxis: [{
tickWidth: 0,
labels: {
groupedOptions: [{
  style: {
		 transform: 'unset'
	 },
}],
style: {
		 transform: 'translateX(11px)'
	 },
	 align: 'right'
},
categories: [
{
name: "Monde",
categories: ["Moyenne 2015-2019", "2020","2021"]
},
{
name: "",
categories: [''] 
},
{
name: "Afrique subsaharienne",
categories: ["Moyenne 2015-2019", "2020","2021"]
},
{
name: "",
categories: [''] 
},
{
name: "Afrique du Nord et Asie de l’Ouest",
categories: ["Moyenne 2015-2019", "2020","2021"]
},
{
name: "",
categories: [''] 
},
{
name: "Asie centrale et Asie du Sud",
categories: ["Moyenne 2015-2019", "2020","2021"]
},
{
name: "",
categories: [''] 
},
{
name: "Asie de l’Est et Asie du Sud-Est",
categories: ["Moyenne 2015-2019", "2020","2021"]
},
{
name: "",
categories: [''] 
},
{
name: "Amérique latine et Caraïbes",
categories: ["Moyenne 2015-2019", "2020","2021"]
},
{
name: "",
categories: [''] 
},
{
name: "Océanie (à l’exception de l’Australie et de la Nouvelle-Zélande)",
categories: ["Moyenne 2015-2019", "2020","2021"]
},
{
name: "",
categories: [''] 
},
{
name: "Europe et Amérique du Nord",
categories: ["Moyenne 2015-2019", "2020","2021"]
},
{
name: "",
categories: [''] 
},
{
name: "Pays les moins avancés (PMA)",
categories: ["Moyenne 2015-2019", "2020","2021"]
},
{
name: "",
categories: [''] 
},
{
name: "Pays en développement sans littoral",
categories: ["Moyenne 2015-2019", "2020","2021"]
},
{
name: "",
categories: [''] 
},
{
name: "Petits pays insulaires en développement",
categories: ["Moyenne 2015-2019", "2020","2021"]
},
{
name: "",
categories: [''] 
},
],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 16,
}],
yAxis: [{
labels: {
style: {
	 fontWeight: 'normal',
	 color: '#999999',
	 fontSize: '12px'
 },
},
opposite: true,
format: '{value}%',
gridLineWidth: 2,
floor: 0,
ceiling: 80,
tickInterval: 10,
title: {
text: '',
style: {
	color: Highcharts.getOptions().colors[1]
}
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
valueSuffix: '%',
style: {
padding: 0
}
},
legend: {
enabled: false,
},

series: [
{
	name: 'Prix alimentaires modérément élevés',
	color: '#fff2cc',
	data: [
	       6.4, 20.4, 8.4, null,
	       9.1, 9.1, 13.6, null,
	       6.1, 26.1, 17.4, null,
	       5, 50, 8.3, null,
	       5.3, 13.3, 13.3, null,
	       6.3, 13.2, 5.3, null,
	       8.3, 25, 8.3, null,
	       4.4, 26.7, 0, null,
	       7.8, 9.8, 14.6, null,
	       10.7, 17.9, 10.7, null,
	       5.7, 15.4, 5.1, null, ]
},
{
	name: 'Prix alimentaires anormalement élevés',
	      color: '#ffc000',
	      data: [
	      8.8, 27.7, 13.1, null,
	      8.6, 29.5, 27.3, null,
	      6.1, 21.7, 4.3, null,
	      8.3, 16.7, 25, null,
	      6.7, 20, 6.7, null,
	      6.3, 36.8, 5.3, null,
	      21.7, 16.7, 25, null,
	      9.8, 28.9, 6.7, null,
	      7.3, 19.5, 19.5, null,
	      7.2, 35.7, 21.4, null,
	      13.3, 30.8, 12.8, null, ]
}]
}
